module.exports = __webpack_public_path__ + "static/media/jm.22cfc0ae.svg";